<template>
	<span class="icon-value-renderer">
		<v-icon v-if="icon" :size="iconSize" class="icon-value-renderer__icon">{{ icon }}</v-icon>
		{{ value }}
	</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	params: { type: Object, required: true },
});

const value = computed(() => props.params?.value ?? '');
const icon = computed(() => props.params?.icon || '');
const iconSize = computed(() => props.params?.iconSize || 18);
</script>

<style lang="scss">
.icon-value-renderer {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: inherit;

	&__icon {
		color: rgba(var(--v-theme-on-surface), 0.6);
	}
}
</style>
